import { render } from "./Coordinates.vue?vue&type=template&id=67743fea&scoped=true"
import script from "./Coordinates.vue?vue&type=script&lang=js"
export * from "./Coordinates.vue?vue&type=script&lang=js"

import "./Coordinates.vue?vue&type=style&index=0&id=67743fea&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67743fea"]])

export default __exports__